module.exports = __webpack_public_path__ + "img/09296295001131.f71a3afa.png";